export default {
	methods: {
		downloadSelectedApplicationCVs(jobApplicationUuids) {
			this.$nuxt.$emit('show-loading-overlay');

			let jobApplications = this.$store.getters['applications/advanced-table/getApplicants'];

			let candidateUuids = [];
			jobApplicationUuids.forEach((uuid) => {
				let row = jobApplications.filter(application => application.job_application_uuid === uuid)[0];

				if (row) {
					candidateUuids.push(row.uuid);
				}
			});

			this.$store
				.dispatch('candidates/unredactedCandidates/downloadMultipleCVs', candidateUuids)
				.then((res) => {
					const downloadLink = document.createElement('a');
					downloadLink.href = `data:application/zip;base64,${res.data.base64}`;
					downloadLink.download = `candidate-cvs.zip`;
					downloadLink.click();
				})
				.catch((err) => {
					this.$toast.show({
						type: 'danger',
						message: err.response.data.message,
					});
				})
				.finally(() => {
					this.$nuxt.$emit('hide-loading-overlay');
				});
		},
		downloadCandidateCV(candidateUuid, candidateName) {
			this.$nuxt.$emit('show-loading-overlay');

			this.$store
				.dispatch('candidates/unredactedCandidates/downloadCV', candidateUuid)
				.then((res) => {
					const downloadLink = document.createElement('a');
					downloadLink.href = `data:application/pdf;base64,${res.data.base64}`;
					downloadLink.download = `${candidateName}.pdf`;
					downloadLink.click();
				})
				.catch((err) => {
					this.$toast.show({
						type: 'danger',
						message: err.response.data.message,
					});
				})
				.finally(() => {
					this.$nuxt.$emit('hide-loading-overlay');
				});
		},
	},
};
